/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LegalRegion } from '../../../../api/model';
import { useGetPsLegalRegionList } from '../../../../api/pss/pss';
import { useDefaultOptions } from '../../../../hooks/api';
import { toString } from '../../../../utils/string';
import ErrorComponent from '../../../atoms/ErrorComponent';
import WaitComponent from '../../../atoms/WaitComponent';
import Modal from '../../../modules/Modal';

interface Props {
  /** モーダル表示・非表示状態。 */
  isOpen: boolean;

  /** モーダル表示・非表示状態設定関数。 */
  setIsOpen: (isOpen: boolean) => void;

  /** すでに選択されている LegalRegion の ID の配列。 */
  selectedLegalRegionIds?: number[] | undefined;

  /** LegalRegion の配列設定関数。 */
  setLegalRegions: (legalRegions: LegalRegion[]) => void;
}

// PS 編集画面で使用。
/** 法規適用国指定ダイアログ。 */
function PsLegalRegionSelectDialog(
  {
    isOpen,
    setIsOpen,
    selectedLegalRegionIds,
    setLegalRegions,
  }: Props
) {
  // i18n 用。
  const {
    t,
    i18n,
  } = useTranslation();

  // API 用。
  const defaultOptions = useDefaultOptions(i18n.language);

  // 法規適用国リスト取得。
  // API 呼び出し。
  const getPsLegalRegionListResponse = useGetPsLegalRegionList(defaultOptions);

  type LegalRegionUiData = {
    legalRegion: LegalRegion;
    selected: boolean;
  };

  /** チェックボックス リストのためのデータ。 */
  const [legalRegionsUiData, setLegalRegionsUiData] = useState<
    LegalRegionUiData[]
    |
    undefined
  >(undefined);

  useEffect(
    () => {
      if (getPsLegalRegionListResponse.isSuccess && (!legalRegionsUiData)) {
        // データ取得時。
        if (Array.isArray(getPsLegalRegionListResponse.data.data)) {
          // 描画用データを設定。
          setLegalRegionsUiData(
            getPsLegalRegionListResponse.data.data.map(
              (legalRegion: LegalRegion) =>
              ({
                legalRegion,
                selected: Boolean(selectedLegalRegionIds?.includes(Number(legalRegion.legal_region_id)))
              })
            )
          );
        }
      }
    },
    [getPsLegalRegionListResponse.data?.data, getPsLegalRegionListResponse.isSuccess, legalRegionsUiData, selectedLegalRegionIds]
  );

  const [previousSelectedLegalRegionIds, setPreviousSelectedLegalRegionIds] = useState<number[] | undefined>(selectedLegalRegionIds);

  useEffect(
    () => {
      if (previousSelectedLegalRegionIds !== selectedLegalRegionIds) {
        // prop の selectedLegalRegionIds が更新されたら。
        if (legalRegionsUiData) {
          // legalRegionsUiData がすでに設定されていた場合。
          setLegalRegionsUiData(
            legalRegionsUiData.map(
              (legalRegionUiData: LegalRegionUiData) =>
              ({
                ...legalRegionUiData,
                // selected を更新。
                selected: Boolean(selectedLegalRegionIds?.includes(Number(legalRegionUiData.legalRegion.legal_region_id)))
              })
            )
          );
        }

        // 比較用に保存。
        setPreviousSelectedLegalRegionIds(selectedLegalRegionIds);
      }
    },
    [legalRegionsUiData, previousSelectedLegalRegionIds, selectedLegalRegionIds]
  );

  return (
    <Modal
      active={isOpen}
      additionalClassName="popupfr700"
      displayCloseButton
      onClose={() => {
        setIsOpen(false);
      }}
    >
      {
        // モーダル内部にメッセージを表示。
        (getPsLegalRegionListResponse.isLoading) ?
          (
            <WaitComponent />
          )
          :
          (
            (getPsLegalRegionListResponse.isError)
            ||
            (!(getPsLegalRegionListResponse.data))
            ||
            (!(Array.isArray(getPsLegalRegionListResponse.data.data)))
          ) ?
            (
              <ErrorComponent error={getPsLegalRegionListResponse.error} />
            )
            :
            (
              <>
                <div className="pop-tablefr2 pop25">
                  <h3>{t('法規適用国指定')}</h3>
                  <div className="popt4fr">
                    <table className="poptable4 w230">
                      <tbody>
                        {
                          (Array.isArray(legalRegionsUiData))
                          &&
                          (
                            legalRegionsUiData.map(
                              (legalRegionUiData: LegalRegionUiData, legalRegionUiDataIndex: number) =>
                              (
                                <tr key={legalRegionUiData.legalRegion.legal_region_id}>
                                  <td>
                                    <span
                                      className="ck-left2"
                                      onClick={
                                        () => {
                                          const newLegalRegionsUiData = [...legalRegionsUiData];

                                          newLegalRegionsUiData[legalRegionUiDataIndex] = {
                                            ...legalRegionUiData,
                                            selected: !(legalRegionUiData.selected),
                                          };

                                          setLegalRegionsUiData(
                                            newLegalRegionsUiData
                                            // legalRegionsUiData.with(legalRegionUiDataIndex,
                                            //   {
                                            //     ...legalRegionUiData,
                                            //     selected: event.target.checked,
                                            //   }
                                            // ) as LegalRegionUiData[]
                                          );
                                        }
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={legalRegionUiData.selected}
                                        readOnly
                                      // onChange={
                                      //   (event) => {
                                      //     console.log('event: ', event);


                                      //     const newLegalRegionsUiData = [...legalRegionsUiData];

                                      //     newLegalRegionsUiData[legalRegionUiDataIndex] = {
                                      //       ...legalRegionUiData,
                                      //       selected: event.target.checked,
                                      //     };

                                      //     setLegalRegionsUiData(
                                      //       newLegalRegionsUiData
                                      //       // legalRegionsUiData.with(legalRegionUiDataIndex,
                                      //       //   {
                                      //       //     ...legalRegionUiData,
                                      //       //     selected: event.target.checked,
                                      //       //   }
                                      //       // ) as LegalRegionUiData[]
                                      //     );
                                      //   }
                                      // }
                                      />
                                      <label>{legalRegionUiData.legalRegion.legal_region_name}</label>
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="btnfr btnfr2w mb0">
                  <div>
                    <span
                      className="btn2 btnbg-g"
                      onClick={
                        () => {
                          setIsOpen(false);
                        }
                      }
                    >
                      <span className="modal-close2">{t('キャンセル')}</span>
                    </span>
                    <span>
                      <input
                        type="button"
                        value={toString(t('選択'))}
                        className="btn1 lsp1"
                        onClick={
                          () => {
                            if (Array.isArray(legalRegionsUiData)) {
                              // LegalRegion の配列を他のコンポーネントに渡す。
                              setLegalRegions(
                                legalRegionsUiData
                                  .filter(
                                    (legalRegionUiData: LegalRegionUiData) =>
                                      // 選択されたものだけにする。
                                      legalRegionUiData.selected
                                  )
                                  .map(
                                    (legalRegionUiData: LegalRegionUiData) =>
                                      legalRegionUiData.legalRegion
                                  )
                              );
                            }

                            setIsOpen(false);
                          }
                        }
                      />
                    </span>
                  </div>
                </div>
              </>
            )
      }
    </Modal>
  );
}

PsLegalRegionSelectDialog.defaultProps = {
  selectedLegalRegionIds: undefined,
};

export default PsLegalRegionSelectDialog;
